import { Add, Close, Search } from '@mui/icons-material';
import { Chip, ChipProps, Tooltip } from '@mui/material';
import { t } from 'i18next';

const iconStyles = {
  transition: 'all 250ms',
  width: '0.625rem',
  height: '0.625rem',
  overflow: 'hidden',
  border: '1px solid',
  borderColor: 'grey.700',
  '& .MuiChip-label': { display: 'none' },
  '& .MuiChip-icon': { margin: 0, opacity: 0, transition: 'inherit' },
  '&:hover, &.Mui-focusVisible, &.expanded': { width: '2rem', height: '2rem', borderColor: 'grey.400', '& .MuiChip-icon': { opacity: 1 } },
};

type Props = Pick<ChipProps<'button'>, 'onClick'> & {
  variant: 'search' | 'add' | 'remove';
  alwaysExpanded: boolean;
};

export const ExpandingIconButton = ({ variant, alwaysExpanded, onClick }: Props) => {
  const iconMap = { add: <Add />, search: <Search />, remove: <Close /> };
  const props: Partial<ChipProps<'button'>> = { icon: iconMap[variant], onClick, 'data-role': `expanding-icon-${variant}` };

  if (variant === 'search') {
    return <Chip component="button" variant="outlined" autoFocus={true} label={t('advancedFilters.search')} {...props} />;
  }

  const tooltipTexts = alwaysExpanded ? { add: t('addExpression'), remove: t('resetFilters') } : { add: t('insertExpression'), remove: t('removeSection') };
  return (
    <Tooltip title={tooltipTexts[variant]}>
      <Chip component="button" className={alwaysExpanded ? 'expanded' : ''} sx={iconStyles} autoFocus={variant === 'add' && alwaysExpanded} {...props} />
    </Tooltip>
  );
};
